// Import Types
import type { SMSProviderFormFields } from './types';

export enum SMSTestSendFieldsEnum {
    MobilePhone = 'MobilePhone',
}

export enum SMSProviderFieldsEnum {
    Url = 'Url',
    ApiKey = 'ApiKey',
    ResponseRegex = 'ResponseRegex',
    Name = 'Name',
    Description = 'Description',
    UserName = 'UserName',
    Password = 'Password',
    FromAddress = 'FromAddress',
    RequestType = 'RequestType',
    MediaType = 'MediaType',
    PostMessageBody = 'PostMessageBody',
    MaxDegreeOfParallelism = 'MaxDegreeOfParallelism',
    DelayTimeout = 'DelayTimeout',
    AdditionalFields = 'AdditionalFields',
    Note = 'Note',
    Type = 'Type',
    Properties = 'Properties',
    Error = 'Error',
    ReplaceBy = 'replaceBy',
    ErrorCode = 'errorCode',
    ErrorMessage = 'errorMessage',
    ExternalId = 'externalId',
    DeliveryStatus = 'deliveryStatus',
    SuccessCode = 'SuccessCode',
    DefaultCode = 'DefaultCode',
    CodeMap = 'CodeMap',
    PartnerId = 'PartnerId',
}

export const SMS_PROVIDER_FORM_DEFAULT_VALUES: SMSProviderFormFields = {
    [SMSProviderFieldsEnum.PartnerId]: null,
    [SMSProviderFieldsEnum.Url]: '',
    [SMSProviderFieldsEnum.ApiKey]: null,
    [SMSProviderFieldsEnum.Name]: '',
    [SMSProviderFieldsEnum.Description]: null,
    [SMSProviderFieldsEnum.UserName]: '',
    [SMSProviderFieldsEnum.Password]: '',
    [SMSProviderFieldsEnum.FromAddress]: null,
    [SMSProviderFieldsEnum.RequestType]: null,
    [SMSProviderFieldsEnum.MediaType]: null,
    [SMSProviderFieldsEnum.PostMessageBody]: null,
    [SMSProviderFieldsEnum.MaxDegreeOfParallelism]: 1,
    [SMSProviderFieldsEnum.DelayTimeout]: 25,
    [SMSProviderFieldsEnum.Note]: null,
    [SMSProviderFieldsEnum.AdditionalFields]: [],
    [SMSProviderFieldsEnum.ResponseRegex]: {
        [SMSProviderFieldsEnum.Type]: null,
        [SMSProviderFieldsEnum.Properties]: {
            [SMSProviderFieldsEnum.ReplaceBy]: '',
            [SMSProviderFieldsEnum.ErrorCode]: '',
            [SMSProviderFieldsEnum.ErrorMessage]: '',
            [SMSProviderFieldsEnum.ExternalId]: '',
            [SMSProviderFieldsEnum.DeliveryStatus]: '',
        },
        [SMSProviderFieldsEnum.Error]: {
            [SMSProviderFieldsEnum.ReplaceBy]: '',
            [SMSProviderFieldsEnum.ErrorCode]: '',
            [SMSProviderFieldsEnum.ErrorMessage]: '',
            [SMSProviderFieldsEnum.ExternalId]: '',
            [SMSProviderFieldsEnum.DeliveryStatus]: '',
        },
        [SMSProviderFieldsEnum.SuccessCode]: null,
        [SMSProviderFieldsEnum.DefaultCode]: null,
        [SMSProviderFieldsEnum.CodeMap]: [],
    },
};

export enum ResponseRegexTypeEnum {
    Json = 0,
    Xml = 1,
    Other = 9,
}

export const REQUEST_TYPE_OPTIONS = [
    { label: 'GET', value: 0 },
    { label: 'POST', value: 1 },
];

export const SMS_RESPONSE_REGEX_TYPE_OPTIONS = [
    { label: 'Json', value: ResponseRegexTypeEnum.Json },
    { label: 'Xml', value: ResponseRegexTypeEnum.Xml },
    { label: 'Other', value: ResponseRegexTypeEnum.Other },
];

export const SMS_TEST_SEND_DEFAULT_VALUES = {
    [SMSTestSendFieldsEnum.MobilePhone]: '',
};
